'use client'

import { useState } from 'react'

import { tw } from '@/lib/utils'

interface FloatFieldProps {
  id: string
  name: string
  label: string
  type: string
  focusedField: string | null
  onFocus: () => void
  onBlur: () => void
}

export const FloatField = ({ id, name, label, type, focusedField, onFocus, onBlur }: FloatFieldProps) => {
  const [value, setValue] = useState('')
  const isActive = focusedField === id || value.length > 0
  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder=" "
        className={tw(
          'text-navy peer w-full bg-transparent px-0 pt-7 pb-3 text-[17px] leading-[1.4] tracking-[-0.01em]',
          'border-b transition-colors duration-300 outline-none placeholder-transparent',
          focusedField === id ? 'border-navy' : 'border-navy/15 hover:border-navy/40'
        )}
      />
      <label
        htmlFor={id}
        className={tw(
          'pointer-events-none absolute left-0 origin-left transition-all duration-300',
          isActive
            ? 'text-navy/55 top-0 scale-[0.92] text-[13px] font-medium tracking-[0.18em] uppercase'
            : 'text-navy/45 top-7 text-[15px] font-normal tracking-[-0.01em]'
        )}
      >
        {label}
      </label>
    </div>
  )
}
